import React from "react";
import { FaPhone } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";

const EAPDetailsModal = ({ isOpen, onClose, showEADItem }) => {
  if (!isOpen || !showEADItem?.options?.[0]) return null;

  const option = showEADItem.options[0];

  return (
    // Overlay with fade transition
    <div
      className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      {/* Modal Container with scale and fade */}
      <div
        className={`bg-white rounded-xl w-full max-w-sm mx-4 p-4 relative shadow-xl transition-all duration-300 ${
          isOpen ? "opacity-100 scale-100" : "opacity-0 scale-95"
        }`}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 p-1 hover:bg-gray-100 rounded-full transition-colors"
          aria-label="Close"
        >
          <IoClose />
        </button>

        {/* Modal Content */}
        <div className="flex flex-col items-center">
          <div className="my-4">
            <img
              src={showEADItem?.image ?? ""}
              alt="ead"
              className="h-24 w-40 object-contain"
            />
          </div>

          <h4 className="text-lg font-semibold text-center mb-2">
            {option?.title ?? ""}
          </h4>

          <p className="text-sm text-gray-600 text-center mb-4">
            {option?.description ?? ""}
          </p>

          <a
            href={`tel:${showEADItem?.mobile ?? ""}`}
            className="w-full bg-indigo-600 text-white py-2 px-4 rounded-lg flex items-center justify-center hover:bg-indigo-700 transition-colors text-decoration-none"
          >
            <FaPhone className="w-5 h-5 mr-2" />
            <span>{showEADItem?.mobile ?? ""}</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default EAPDetailsModal;
